"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'seattle',
    name: 'Seattle',
    background_color: '#343434',
    background_image: 'https://assets.raydiant.com/images/seattle.jpg',
    background_image_portrait: 'https://assets.raydiant.com/images/seattle-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/Roboto-Bold.woff',
    heading_text_color: '#ffffff',
    heading_2_font: 'https://fonts.raydiant.com/Roboto-Bold.woff',
    heading_2_text_color: '#ffffff',
    body_font: 'https://fonts.raydiant.com/Roboto-Light.woff',
    body_text_color: '#ffad0a',
    border_color: '#ffffff',
};
//# sourceMappingURL=seattle.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/seattle.js